module.exports = "<p>\n  controles works!\n</p>\n"